<template>
  <div class="disponibilidad">
    <control-usuarios />
  </div>
</template>

<script>
import ControlUsuarios from '@/components/controlUsuarios/ControlUsuarios.vue'
export default {
  name: 'Disponibilidad',
  components: {
    ControlUsuarios
  }
}
</script>
